<template>
  <main>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <form-select :model="filterFormModel" attribute="status" class="mr-1 mb-1" :options="[
                {value: null, text: $t('all')},
                {value: 'activated', text: $t('activated')},
                {value: 'deactivated', text: $t('deactivated')}
            ]"></form-select>
            <client-select v-if="!client" :model="filterFormModel" class="mr-1 mb-1" attribute="client" @change="search"
                           :isFilter="true" :place-holder="$t('selectClient') "></client-select>
            <gateway-select :service="'/sms-gateway'" :model="filterFormModel" attribute="gateway"
                            class="mr-1 mb-1"></gateway-select>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-sorting"
             v-if="['owner', 'admin', 'tech', 'account', 'operationsManager'].includes($store.state.user.role)">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right"
                            size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize"
                            @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-3">{{ $t('client') }}</div>
            <div class="col-lg-4">{{ $t('smsBrandNameInfo') }}</div>
            <div class="col-lg-3">{{ $t('status') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-3">
              <span v-if="item.client && item.client.companyName">{{ item.client.companyName }}</span>
              <span v-if="item.client && item.client.domain">({{ item.client.domain }})</span>
            </div>
            <div class="col-lg-4">
              <p>
                <b>{{ $t('name') }}</b>: {{ item.name }}
                <span v-if="item.privateFee" class="badge badge-info">{{ $t('privateFee') }}</span>
              </p>
              <p v-if="item.username">
                <b>{{ $t('username') }}</b>: {{ item.username }}
              </p>
              <p v-if="item.gateway">
                <b>{{ $t('gateway') }}</b>: {{ item.gateway.name }}
              </p>
              <p v-if="item.ads">
                <b>{{ $t('adsFee') }}: </b>
                <span>{{
                    (item.privateFee ? (item.adsFee ? item.adsFee : 0) : (item.gateway ? item.gateway.adsFee : '-')) | numFormat
                  }}</span>
              </p>
              <p v-if="item.care">
                <b>{{ $t('careFee') }}: </b>
                <span>{{
                    item.privateFee ? (item.careFee ? item.careFee : 0) : (item.gateway ? item.gateway.careFee : '-') | numFormat
                  }}</span>
              </p>
              <p v-if="item.care">
                <b>{{ $t('monthlyFee') }}: </b>
                <span>{{
                    item.privateFee ? (item.monthlyFee ? item.monthlyFee : 0) : (item.gateway ? item.gateway.monthlyFee : '-') | numFormat
                  }}</span>
              </p>
              <p v-if="item.ads && !item.care">
                <b>{{ $t('monthlyFeeAdsOnly') }}: </b>
                <span>{{
                    item.privateFee ? (item.monthlyFeeAdsOnly ? item.monthlyFeeAdsOnly : 0) : (item.gateway ? item.gateway.monthlyFeeAdsOnly : '-') | numFormat
                  }}</span>
              </p>
              <div class="c-button__col">
                <s-m-s-template :brandName="item"></s-m-s-template>
              </div>
            </div>
            <div class="col-lg-3">
              <p>
                <span class="badge badge-success" v-if="item.approveTime">{{ $t('approved') }}</span>
                <span class="badge badge-danger" v-else-if="item.denyTime">{{ $t('denied') }}</span>
                <!-- Cả hai mốc = 0 là hồ sơ mới chờ xử lý, trước đây cột này bỏ trống. -->
                <span class="badge badge-warning" v-else>{{ $t('waiting') }}</span>
              </p>
              <p>
                <b>{{ $t('createTime') }}: </b><span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </p>
              <p v-if="item.updateTime">
                <b>{{ $t('updateTime') }}: </b><span>{{ item.updateTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </p>
              <p v-if="item.approveTime">
                <b>{{ $t('approveTime') }}: </b><span>{{ item.approveTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </p>
              <p v-if="item.denyTime">
                <b>{{ $t('denyTime') }}: </b><span>{{ item.denyTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </p>
            </div>
            <div class="col-lg-2">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col"
                       v-if="['owner', 'admin', 'account', 'operationsManager'].includes($store.state.user.role)">
                    <button @click="update(item._id)" class="btn btn-info btn-sm mr-1" type="button">
                      <font-awesome-icon icon="edit"/>
                      {{ $t('edit') }}
                    </button>
                    <button v-if='!item.approveTime' @click="changeStatus(item._id, 'approve')"
                            class="btn btn-success btn-sm mr-1" type="button">
                      <font-awesome-icon icon="check"/>
                      {{ $t('activate') }}
                    </button>
                    <button v-if='!item.denyTime' @click="changeStatus(item._id, 'deny')"
                            class="btn btn-danger btn-sm mr-1" type="button">
                      <font-awesome-icon icon="window-close"/>
                      {{ $t('lock') }}
                    </button>
                    <div class="c-button__col">
                      <charge-register-fee :brand-name="item" v-if="!item.registerCount"></charge-register-fee>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span>{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount"
                      :per-page="filterFormModel.pageSize"
                      @input="load"></b-pagination>
      </div>
    </div>
    <b-modal v-model="showForm" :title="formTitle" no-close-on-backdrop no-enforce-focus>
      <client-select :label="$t('client')" :model="formModel" attribute="client" :errors="formErrors" />
      <form-input :label="$t('name')" :model="formModel" attribute="name" :errors="formErrors" />

      <form-select :model="formModel" attribute="gateway" :options="gatewayOptions" :errors="formErrors"
                   label="Gateway" />

      <form-textarea :label="$t('desc')" :model="formModel" attribute="desc" :errors="formErrors" />

      <template v-if="gateway && gateway.name === 'vnpt'" >
        <div  class="row">
          <div class="col-md" >
            <form-input label="CONTRACTID" :model="formModel" attribute="secretKey" :errors="formErrors" />
          </div>
          <div class="col-md">
            <form-input :label="$t('username')" :model="formModel" attribute="username" :errors="formErrors"></form-input>
          </div>
        </div>
        <div  class="row">
          <div class="col-md" >
            <form-input label="APIUSER" :model="formModel" attribute="apiKey" :errors="formErrors" />
          </div>
          <div class="col-md" >
            <form-input label="APIPASS" :model="formModel" attribute="pwd" :errors="formErrors"></form-input>
          </div>
        </div>
        <div  class="row">
          <div class="col-md" >
            <form-input label="AGENTID" :model="formModel" attribute="serviceId" :errors="formErrors" />
          </div>
          <div class="col-md" >
            <form-input label="LABELID" :model="formModel" attribute="desc" :errors="formErrors" />
          </div>
        </div>
      </template>
      <template v-else-if="gateway && gateway.name === 'yoursales'" >
        <form-input label="API Key" :model="formModel" attribute="pwd" :errors="formErrors" />
        <div class="alert alert-warning">
          Cần cài đặt webhook trên port của yoursales.vn
          <ul>
            <li>Webhook CSKH: <span class="text-danger">{{clientUrl}}/webhook/yoursales/cskh</span></li>
            <li>Webhook Quảng cáo: <span class="text-danger">{{clientUrl}}/webhook/yoursales/qc</span></li>
          </ul>
        </div>
      </template>
      <template v-else>
        <form-input :label="$t('username')" :model="formModel" attribute="username" :errors="formErrors"></form-input>

        <form-input label="Service Id" :model="formModel" attribute="serviceId" :errors="formErrors" />
      </template>


      <form-checkbox :model="formModel" attribute="ads" :errors="formErrors" :chk-label="$t('ads')"></form-checkbox>
      <form-checkbox :model="formModel" attribute="care" :errors="formErrors" :chk-label="$t('care')"></form-checkbox>
      <form-checkbox :model="formModel" attribute="privateFee" :errors="formErrors"  :chk-label="$t('privateFee')" />
      <form-input v-if="formModel.privateFee && formModel.ads" :model="formModel" attribute="adsFee"
                  :label="$t('adsFee')" :errors="formErrors" />
      <form-input v-if="formModel.privateFee && formModel.care" :model="formModel" attribute="careFee"
                  :label="$t('careFee')" :errors="formErrors" />
      <form-input v-if="formModel.privateFee && formModel.care" :model="formModel" attribute="monthlyFee"
                  :label="$t('monthlyFee')"
                  :errors="formErrors" />
      <form-input v-if="formModel.privateFee && !formModel.care && formModel.ads" :model="formModel"
                  attribute="monthlyFeeAdsOnly" :label="$t('monthlyFeeAdsOnly')"
                  :errors="formErrors" />
      <template v-slot:modal-footer>
        <button @click="showForm=false" class="btn btn-secondary">{{ $t('cancel') }}</button>
        <button @click="save" class="btn btn-primary">{{ $t('save') }}</button>
      </template>
    </b-modal>
  </main>
</template>

<script>
import list from '@/mixins/List';
import crud from '@/mixins/CRUD';
import SMSTemplate from "./SMSTemplate";
import ClientSelect from "@/components/ClientSelect";
import _ from 'lodash';
import ChargeRegisterFee from "@/views/sms/ChargeRegisterFee";
import GatewaySelect from "@/components/GatewaySelect.vue";

export default {
  props: {
    client: Object
  },
  mixins: [list, crud],
  components: {ClientSelect, ChargeRegisterFee, SMSTemplate, GatewaySelect},
  data: function () {
    return {
      defaultFilterFormModel: {
        status: null,
        client: this.client ? this.client._id : null,
        keyword: null,
        gateway: null,
      },
      autoLoad: true,
      service: '/sms-brand-name',
      gatewayOptions: [],
      gateways: [],
      defaultFormModel: {
        client: this.client ? this.client._id : null,
        name: null,
        desc: null,
        gateway: null,
        username: null,
        pwd: null,
        serviceId: null,
        privateFee: false,
        ads: false,
        care: false,
        adsFee: null,
        careFee: null,
        unlimitedTemplateLength: null,
        monthlyFee: null,
        monthlyFeeAdsOnly: null,
      },
      formTitle: '',
      clientUrl: process.env.VUE_APP_CLIENT_URL
    }
  },
  computed: {
    gateway() {
      if(this.formModel.gateway && this.gateways.length) {
        return this.gateways.find(g => g._id === this.formModel.gateway);
      }
      return null
    }
  },
  methods: {
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
    smsTemplate(item) {
      this.$bus.$emit('smsTemplate', item);
    },
    changeStatus: function (id, type) {
      this.$swal({
        title: type === 'deny' ? this.$t('denyConfirm') : this.$t('approveConfirm'),
        icon: "info",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          let loader = this.$loading.show();
          this.$service({
            url: this.service + '/change-status/' + id,
            method: 'put',
            data: {type: type}
          }).then(response => {
            if (response.data) {
              if (this.load) {
                this.load();
              }
              if (this.reloadBus) {
                this.$bus.$emit(this.reloadBus);
              }
              this.$swal({
                title: this.$t('success'),
                text: type === 'deny' ? this.$t('brandNameDenied') : this.$t('brandNameApproved'),
                icon: 'success'
              });
            } else {
              this.$swal({
                title: this.$t('error'),
                icon: 'error'
              });
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            }
          }).finally(() => {
            loader.hide();
          });
        }
      });
    },
    getGateways() {
      this.gatewayOptions = [{value: null, text: this.$t('chooseSMSGateway')}];
      this.$bgService.get('/sms-gateway/', {
        params: {
          page: 1,
          pageSize: 1000,
        }
      }).then(response => {
        this.gateways = response.data.docs;
        response.data.docs.forEach(item => {
          this.gatewayOptions.push({value: item._id, text: item.name});
        });
      })
    },
    update(id) {
      let loader = this.$loading.show();
      this.$service.get(this.service + '/' + id).then(response => {
        this.formModel = {};
        this.formTitle = this.$t('update');
        this.formErrors = [];
        this.showForm = true;
        this.formModel = response.data;
        if (this.formModel.adsFee === 0) {
          this.formModel.adsFee = '0'
        }
        if (this.formModel.careFee === 0) {
          this.formModel.careFee = '0'
        }
        if (this.formModel.monthlyFee === 0) {
          this.formModel.monthlyFee = '0'
        }
        if (this.formModel.monthlyFeeAdsOnly === 0) {
          this.formModel.monthlyFeeAdsOnly = '0'
        }
        this.formModel.id = id;
      }).finally(() => {
        loader.hide();
      });
    },
  },
  mounted() {
    this.getGateways();
    this.$bus.$on('loadBrandName', this.load)
  },
  beforeDestroy() {
    this.$bus.$off('loadBrandName')
  },
  i18n: {
    messages: {
      en: {
        type: "Type",
        smsTemplate: "Template",
        approved: "Approved",
        waiting: "Waiting",
        denied: "Denied",
        ads: "Ads",
        care: "Customer care",
        draft: "Draft",
        templateList: "Template list",
        approve: "Approve",
        deny: "Deny",
        cancel: "Cancel",
        adsFee: "Fee/ads SMS",
        careFee: "Fee/customer care SMS",
        monthlyFee: "Monthly fee - Care & Ads",
        monthlyFeeAdsOnly: 'Monthly fee - Ads only',
        denyConfirm: "Are you sure to deny this brand name?",
        smsBrandNameInfo: "SMS brand name info",
        chooseSMSGateway: "Choose SMS gateway",
        privateFee: "Private fee",
        brandNameApproved: "Brand name approved!",
        brandNameApprovedFailed: "Brand name approved failed",
        brandNameDenied: "Brand name denied!",
        brandNameDeniedFailed: "Brand name denied failed!",
        save: "Save",
        username: "Username",
        pwd: "Password",
        unlimitedTemplateLength: "Unlimited template length",
        approveBrandName: "Approve brand name",
        updateBrandName: "Update brand name",
        approveTime: "Approve time",
        denyTime: "Deny time",
        approveConfirm: "Are you sure to approve this brand name?"
      },
      vi: {
        type: "Loại",
        smsTemplate: "Mẫu",
        approved: "Đã duyệt",
        waiting: "Đợi duyệt",
        denied: "Đã từ chối",
        ads: "Quảng cáo",
        care: "CSKH",
        draft: "Nháp",
        templateList: "DS mẫu",
        approve: "Duyệt",
        deny: "Từ chối",
        cancel: "Huỷ",
        adsFee: "Giá/SMS quảng cáo",
        careFee: "Giá/SMS CSKH",
        monthlyFee: "Phí hàng tháng - CSKH & QC",
        monthlyFeeAdsOnly: 'Phí hàng tháng - chỉ QC',
        denyConfirm: "Bạn có chắc muốn khoá SMS Brand name này?",
        smsBrandNameInfo: "Thông tin SMS brand name",
        chooseSMSGateway: "Chọn SMS gateway",
        privateFee: "Bảng phí riêng",
        brandNameApproved: "Đã duyệt SMS brand name",
        brandNameApprovedFailed: "Duyệt SMS brand name thất bại",
        brandNameDenied: "Đã từ chối brand name!",
        brandNameDeniedFailed: "Từ chối brand name thất bại",
        save: "Lưu",
        username: "Tên đăng nhập",
        pwd: "Mật khẩu",
        unlimitedTemplateLength: "Không giới hạn độ dài template",
        approveBrandName: "Duyệt brand name",
        updateBrandName: "Cập nhật brand name",
        approveTime: "Duyệt lúc",
        denyTime: "Từ chối lúc",
        approveConfirm: "Bạn có chắc muốn kích hoạt brand name này?"
      }
    }
  }
}
</script>